import { registerComponent, asyncRequest, debounce, loading } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "cart-items",
  class CartItems extends WYATTElement {
    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0,
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
      this.form?.addEventListener("keydown", this.handleKeydown.bind(this));
    }

    handleKeydown(event) {
      if (event.key !== "Enter") {
        return;
      }

      if (!(event.target instanceof HTMLInputElement)) {
        return;
      }

      if (event.target.name !== "updates[]") {
        return;
      }

      // Prevent implicit form submit (checkout button is type=submit on this form).
      event.preventDefault();

      if (event.target.value === event.target.defaultValue) {
        return;
      }

      event.target.dispatchEvent(new Event("change", { bubbles: true }));
    }

    remove(event) {
      const line = event.currentTarget.dataset.removeItemButton;

      event.preventDefault();

      this.updateQuantity(line, 0);
    }

    handleChange(event) {
      const input = event.target;

      if (!(input instanceof HTMLInputElement)) {
        return;
      }

      if (!input.dataset.lineItemIndex) {
        return;
      }

      // Enter can fire `change` even when the value was not edited.
      if (input.value === input.defaultValue) {
        return;
      }

      this.updateQuantity(input.dataset.lineItemIndex, input.value);
    }

    async updateQuantity(line, quantity) {
      loading.add(this);

      await WYATT.Cart.ready;

      const body = {
        line,
        quantity,
        sections: WYATT.Cart.getSectionNames(),
        sections_url: window.location.pathname,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-dialog-messages], #page-messages',
          },
        },
      );

      if (response) {
        await this.handleSuccessfulUpdate(response);
      } else {
        await WYATT.Cart.reseed();
      }

      loading.remove(this);
    }

    async handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);
      const result = await WYATT.Cart.applyChangeResponse(parsedState);

      if (result?.sections) {
        this.publish(
          WYATT.PubSub.events.updateDOM,
          WYATT.Cart.sectionUpdates(result.sections),
        );
      }
    }
  },
);
